import api from '@/lib/axios';

export interface TaskTag {
  id: string;
  name: string;
  color: string;
  icon?: string | null;
  tenantId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTaskTagDto {
  name: string;
  color?: string;
  icon?: string;
}

export interface UpdateTaskTagDto {
  name?: string;
  color?: string;
  icon?: string;
}

export const taskTagsService = {
  getAll: async (): Promise<TaskTag[]> => {
    const { data } = await api.get<TaskTag[]>('/task-tags');
    return Array.isArray(data) ? data : [];
  },

  create: async (dto: CreateTaskTagDto): Promise<TaskTag> => {
    const { data } = await api.post<TaskTag>('/task-tags', dto);
    return data;
  },

  update: async (id: string, dto: UpdateTaskTagDto): Promise<TaskTag> => {
    const { data } = await api.put<TaskTag>(`/task-tags/${id}`, dto);
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/task-tags/${id}`);
  },
};
